<template>
  <AdBaseVue
    class="cs"
    :tp="'N2'"
    :google_pc_wid="'300px'"
    :google_pc_hgt="'250px'"
    :google_mobile_wid="'300px'"
    :google_mobile_hgt="'25%'"
  ></AdBaseVue>
</template>

<script>
import AdBaseVue from "./AdBase.vue";

export default {
  data() {
    return {};
  },
  components: {
    AdBaseVue,
  },
};
</script>

<style scoped>
.cs {
  width: 300px;
  height: 250px;
}
@media (max-width: 575px) {
  .cs {
    width: 100%;
    height: 90px;
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Ad/N2.vue